export default {

    //General phrases
    tollWord: 'Brückengebühr fetesti | Brückengebühren fetesti | Mautgebühren',
    vignetteWord: 'Vignette | Vignetten',

    site_tpf: 'taxa-pod-fetesti.ro',
    site_erv: 'e-rovinieta.ro',

    currency: 'Lei',
    category: 'Kategorie',
    select_type_of_vehicle: 'Fahrzeugart auswählen',
    select_the_period: 'Select the period',
    or_pay_for: 'Oder bezahlen für',
    your_vehicles_link: 'Deine Fahrzeuge',
    or_go_to_your_account_and_buy: 'Oder Ihr Konto auswählen und direkt für deine Fahrzeuge kaufen',
    see_cart: ' Warenkorb ansehen',
    or: 'oder',
    and: 'und',
    back: 'zurück',
    total: 'Gesamt',
    pf: 'Natürliche Person',
    pj: 'Juristische Person',
    yes: 'Ja',
    no: 'Nein',
    about: 'Über',
    us: 'Uns',

    vignette: 'Vignette | Vignetten',
    passing: 'Übertritt | Übertretungen',

    toll_buy: 'Brückengebühr zahlen',
    vignette_buy: 'Vignette zahlen',

    //Order
    billing_add_new_profile: ' Neues Abrechnungsprofil hinzufügen',

    cart_empty: 'Der Warenkorb ist leer',
    cart_available_from: 'gültig seit',
    cart_add_more: 'Hinzufügen weitere Produkte im Warenkorb',
    cart_continue_with_buying: 'Weitere kaufen',
    cart_validation_errors: 'Produkte aufgrund von Validierungsfehlern aus der Bestellung entfernt',

    order_container_place_order_title: 'Bestellung platzieren',
    order_container_my_cart: 'Mein Warenkorb',
    order_container_billing_info: 'Rechnungsangaben',
    order_container_payment: 'Zahlung',

    payment_method_insuficient_credit: 'unzureichender Kredit',
    payment_method_instant_credit: 'Sofortiger Kredit',
    payment_method_instant_credit_description: 'Sofortiger Kredit',
    payment_method_credit_card: 'Online mit Bankkarte',
    payment_method_credit_card_description: 'Die Zahlung wird durch PayU.ro bearbeitet',
    payment_method_iTransfer_description: 'Zahlungsauftrag mit sofortiger Bestätigung',
    payment_method_payment_order: 'Zahlungsauftrag',
    payment_method_payment_order_description: 'Sie erhalten per E-Mail das mit dem Kauf verbundene Formblatt mit den Zahlungsanweisungen. Die Bestellung wird nach Zahlungseingang ausgestellt',
    payment_method_credit_erv: 'Kredit E-Vignette',
    payment_method_credit_tpf: 'Kredit Brückengebühr fetesti',
    payment_method_terms: 'Ich bestätige, dass die oben genannten Daten korrekt sind und, dass ich die Allgemeinen Geschäftsbedingungen gelesen habe und ihnen zustimme',

    thank_you_placed_order_title: 'Bestellung platziert',
    thank_you_successful_order: 'Die Bestellung wurde erfolgreich platziert!',
    thank_you_see_info_order: 'Status in meinen Bestellungen ansehen',
    thank_you_my_orders: 'Meine Bestellungen',

    //Account
    continue_with: 'Continue with',
    account_activate_header: 'Konto aktivieren',
    account_activate_message: '',

    account_container_my_account: 'Mein Konto',
    account_container_vehicles: 'Fahrzeuge',
    account_container_orders: 'Bestellungen',
    account_container_profiles: 'Abrechnungsprofile',
    account_container_info: 'Kontoangaben',

    account_data_title: 'Kontodetails',

    add_car_title: 'Fahrzeug hinzufügen',

    add_profile_title: 'Profil hinzufügen',
    add_profile_pj_extracted: 'Automatisch entnommene Angaben der juristischen Person',

    edit_car_no_vehicles: 'Kein Fahrzeug gefunden!',
    edit_car_delete_vehicle_title: 'Fahrzeug löschen',
    edit_car_delete_vehicle: 'Möchten Sie dieses Fahrzeug wirklich löschen?',

    my_orders_passings: 'Übertritt | {count} Übertritte',

    profiles_main: 'Haupt',
    profiles_secondary: 'Sekundär',
    profiles_unverified_data: 'Ungeprüfte Angaben',
    profiles_no_profile: 'Kein Profil vorhanden',
    profiles_delete_profile: 'Profil löschen',
    profiles_are_you_sure: 'Möchten Sie das Profil wirklich löschen? ',

    //Authentication
    login_auth: 'Beglaubigung',
    login_login_into_your_account: 'Ins Konto einloggen',

    login_component_login_by: 'Einloggen mit',
    login_component_no_account: 'Haben Sie kein Konto?',
    login_component_forgot_password: 'Passwort vergessen?',

    new_account_title: 'Neues Konto',
    new_account_details: 'Kontodetails',
    new_account_ive_read: 'Ich habe gelesen und bin damit einverstanden',
    new_account_tc: 'Allgemeine Geschäftsbedingungen',
    new_account_site: 'der Webseite',
    new_account_pc: 'Datenschutzrichtlinie',
    mandatory: 'Verbindlich',
    new_account_must_accept_tc: 'Sie müssen die Geschäftsbedingungen akzeptieren',
    new_account_must_accept_pc: 'Sie müssen die Datenschutzrichtlinie akzeptieren',

    contact_title: 'Kontakt',

    header_how_does_it_work: 'Wie funktioniert es?',

    how_it_works_p1: 'Sie machen sich in 3 Minuten auf den Weg!',
    how_it_works_p2: 'Zugelassener Vertreiber der Nationalen Gesellschaft für Verwaltung der Straßeninfrastruktur - CNAIR',
    how_it_works_p3: 'Online bestellen mit taxa-pod-fetesti.ro',

    toll_category_error_loading_car: 'Problem beim Laden des Fahrzeugs',
    toll_category_error_loading_country: 'Problem beim Laden der Länder',

    vignette_category_error_fromdate: 'Datum des Inkrafttretens der Vignette auswählen',

    //Buttons
    btn_save: 'Speichern',
    btn_save_changes: 'Änderungen speichern',
    btn_add_car: 'Fahrzeug hinzufügen',
    btn_delete_car: 'Fahrzeug löschen',
    btn_next_step: 'Nächster Schritt',
    btn_finish: 'Beenden',
    btn_grab_data_company: 'Daten übernehmen <br/> Handelsregister',
    btn_add_profile: 'Neues Profil hinzufügen',
    btn_i_understand: 'Ich habe verstanden',
    btn_login: 'Einloggen',
    btn_register: 'Registrieren',
    btn_create_account: 'Konto einrichten',
    btn_add_to_cart: 'Im Warenkorb hinzufügen',
    btn_edit_to_cart: 'Produkt ändern',
    btn_reset_password: 'Passwort zurücksetzen',
    btn_bill: 'Factureaza',
    btn_choose_payment_method: 'Choose payment method',


    //Labels
    label_email: 'E-Mail',
    label_password: 'Passwort',
    label_confirm_password: 'Passwort bestätigen',
    label_license_plate: 'Amtliches Kennzeichen',
    label_chasis_number: 'Fahrgestellnummer',
    label_registration_country: 'Zulassungsland',
    label_motif: 'Grund für die niedrige Kategorie',
    label_choose_category: 'Auswählen Kategorie für',
    label_billing_type: 'Rechnungsstellung für',
    label_last_name: 'Vorname',
    label_first_name: 'Name',
    label_country: 'Land',
    label_county: 'Kreis',
    label_city: 'Stadt',
    label_address: 'Anschrift',
    label_cui: 'Einheitliche Registriernummer',
    label_reg_com: 'Handelsregister',
    label_locality: 'Ortschaft',
    label_company_name: 'Firmenname',
    label_for_car: 'Für das Fahrzeug',
    label_available_from: 'Gültig ab dem',

    //terms
    terms: 'Geschäftsbedingungen',
    partners: 'Partner',

    delete_product_title: 'Delete product',
    delete_product: 'Are you sure you want to delete this product?',

    sms_notice: '<strong>Kostenpflichtiger SMS-Benachrichtigungsdienst</strong><br/><br/> Der Benachrichtigungsdienst durch Kurznachrichten (SMS) ermöglicht die Benachrichtigung der Kunden von www.taxa-pod-fetesti.ro über die Bestätigung der Brückenmaut bzw. die Benachrichtigung von Kunden über den Ablauf der Gültigkeit der Brückenmaut. Die Dienstleistung ist fakultativ und steht nur für Bestellungen, die online über den Zahlungsdienstleister (PayU) bezahlt werden, zur Verfügung.<br/><br/> Für die Richtigkeit der Daten und Informationen in der SMS über die Erteilung und/oder den Ablauf der Brückenmaut, die Zulassungsnummer, die Fahrgestellnummer und die auf der Plattform www.taxa-pod-fetesti.ro eingegebene Handynummer ist ausschließlich der Nutzer verantwortlich.<br/><br/> Die SMS-Benachrichtigung erfolgt über NETOPIA Payments.<br/><br/> Das SMS-Benachrichtigungssystem sendet Benachrichtigungen an Kunden, die sich für diesen Dienst entscheiden.<br/><br/> Der Empfang von Bestätigungs-/Ablauf-SMS kann durch den Betrieb und die Versorgungsbereiche von Telekommunikationsnetzen, den Betrieb der verwendeten Geräte usw. beeinträchtigt werden.<br/><br/> Für Anzeigen nutzen Sie bitte die Kontaktseite der Website www.taxa-pod-fetesti.ro.<br/><br/>'

};
